export default "__VITE_ASSET__BkXuTk7b__"